import React, { createContext, useCallback, useState } from 'react';

export const UndoContext = createContext({
  showUndo: () => {},
});

export function UndoProvider({ children }) {
  const [undo, setUndo] = useState({ visible: false, message: '', onUndo: null });

  const showUndo = useCallback((message, onUndo, timeout = 5000) => {
    setUndo({ visible: true, message, onUndo });
    if (timeout > 0) {
      setTimeout(() => setUndo((prev) => ({ ...prev, visible: false })), timeout);
    }
  }, []);

  const hideUndo = useCallback(() => setUndo((prev) => ({ ...prev, visible: false })), []);

  return (
    <UndoContext.Provider value={{ showUndo, hideUndo, undo }}>
      {children}
    </UndoContext.Provider>
  );
}

export default UndoProvider;
